import { environment } from 'src/environments/environment';

export function userIcheck(campaign: any) {
    if (!campaign) return false;
    if (!environment.userIcheck) return false;
    if (!environment.userIcheck.userId.includes(campaign.owner.id)) return false;
    return true;
}